import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, SimpleChanges } from "@angular/core";
import { getMainMenuWidth } from "components/cs-menu/cs-menu";
import { setSmallScreenMaxSize, smallScreenMaxWidthBase } from 'environments/environment-helpers';
import { getSideMenuCollapsedWidth } from 'services/browser-utils';

@Component({
  selector: 'cs-split-pane',
  templateUrl: 'cs-split-pane.html',
  host: { 'class': 'split-pane' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsSplitPaneComponent {

  @Input() when: boolean;

  constructor(
    public elementRef: ElementRef,
    private cd: ChangeDetectorRef) {
  }

  resizeObserver = new ResizeObserver(() => this.updateClasses());

  getNativeElement() {
    return this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.resizeObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    this.resizeObserver.disconnect();
  }

  updateClasses() {
    const element = this.elementRef.nativeElement as HTMLElement;
    const fullMenuWidth = getMainMenuWidth();
    const collapsedMenuWidth = getSideMenuCollapsedWidth();
    const screenWidth = document.documentElement.clientWidth;

    // Breakpoints:
    // - Full menu: width >= smallScreenMaxWidthBase + fullMenuWidth (e.g., 800 + 260 = 1060)
    // - Collapsed menu: width >= smallScreenMaxWidthBase + collapsedMenuWidth (e.g., 800 + 70 = 870)
    // - No menu (bottom nav): width < smallScreenMaxWidthBase + collapsedMenuWidth
    const fullMenuBreakpoint = smallScreenMaxWidthBase + fullMenuWidth;
    const collapsedMenuBreakpoint = smallScreenMaxWidthBase + collapsedMenuWidth;

    if (this.when && screenWidth >= fullMenuBreakpoint) {
      // Full menu visible
      setSmallScreenMaxSize(fullMenuBreakpoint);
      element.classList.add('split-pane-visible');
      element.classList.remove('menu-collapsed');
    } else if (this.when && screenWidth >= collapsedMenuBreakpoint) {
      // Collapsed menu visible (icon-only rail)
      setSmallScreenMaxSize(collapsedMenuBreakpoint);
      element.classList.add('split-pane-visible');
      element.classList.add('menu-collapsed');
    } else {
      // No menu - small screen with bottom nav
      setSmallScreenMaxSize(smallScreenMaxWidthBase);
      element.classList.remove('split-pane-visible');
      element.classList.remove('menu-collapsed');
    }
    this.cd.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.when) {
      this.updateClasses();
    }
  }
}